// AvgTimeToHire.jsx
import React from "react";
import { Card } from "react-bootstrap";
import { FiDownload, FiArrowUpRight } from "react-icons/fi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Jan", a: 2, b: 2, c: 4, d: 3 },
  { name: "Feb", a: 4, b: 2, c: 2, d: 7 },
  { name: "Mar", a: 3, b: 2, c: 2, d: 5 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="att-tooltip">
        <strong>{label}</strong>
        <div className="d-flex align-items-center gap-2 mt-1">
          <span className="box"></span>
          Interview to Offer: {payload[2].value}
        </div>
      </div>
    );
  }
  return null;
};

export default function AvgTimeToHire() {
  return (
    <Card className="att-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="att-header">
          <h6>Average Time To Hire</h6>
          <span className="att-range">
            <FiDownload /> Last 30 Days
          </span>
        </div>

        {/* CHART */}
        <div className="att-chart">
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={data} barCategoryGap="30%">
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />

              <Bar dataKey="a" stackId="a" fill="#0f4c5c" radius={[4,4,0,0]} />
              <Bar dataKey="b" stackId="a" fill="#3b6c77" />
              <Bar dataKey="c" stackId="a" fill="#7a9aa3" />
              <Bar dataKey="d" stackId="a" fill="#cfd8dc" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* LIST */}
        <div className="att-list">
          {[
            ["Applied to Shortlisted", "05", "#0f4c5c"],
            ["Shortlisted", "07", "#3b6c77"],
            ["Interview to Offer", "10", "#7a9aa3"],
            ["Acceptance", "03", "#cfd8dc"],
          ].map((item, i) => (
            <div className="att-item" key={i}>
              <div className="left">
                <span
                  className="dot"
                  style={{ background: item[2] }}
                ></span>
                {item[0]}
              </div>
              <span className="value">{item[1]}</span>
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="att-footer">
          <div className="icon">
            <FiArrowUpRight />
          </div>
          <span>12% faster than industry avg</span>
        </div>

      </Card.Body>

      {/* ================= EXACT CSS ================= */}
      <style>{`

        .att-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        .att-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .att-header h5 {
          font-weight: 600;
        }

        .att-range {
          font-size: 13px;
          color: #6b7280;
        }
            .att-range:hover {
        color: #f97316 !important;
        }

        /* CHART */
        .att-chart {
          margin-bottom: 15px;
        }

        /* TOOLTIP */
        .att-tooltip {
          background: #111;
          color: #fff;
          padding: 8px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        .att-tooltip .box {
          width: 10px;
          height: 10px;
          background: #cfd8dc;
          display: inline-block;
        }

        /* LIST */
        .att-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .att-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .left {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #374151;
        }

        .dot {
          width: 6px;
          height: 14px;
          border-radius: 3px;
        }

        .value {
          background: #f3f4f6;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 13px;
        }

        /* FOOTER */
        .att-footer {
          margin-top: 15px;
          background: #e6f4ea;
          padding: 10px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 500;
        }

        .att-footer .icon {
          background: #16c172;
          color: #fff;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .att-chart {
            height: 160px;
          }
        }

      `}</style>
    </Card>
  );
}